import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Box, Typography } from '@material-ui/core'
import ScrollToTopOnMount from '../components/ScrollToTopOnMount'
import UpdatePage from '../components/UpdatePage'
import HeaderImg from '../components/HeaderImg'
import LazyImg from '../components/LazyImg'
import about_ph from '../images/about_ph.jpg'
import about_mobile from '../images/about_small.jpg'
import about_desktop from '../images/about_med.jpg'
import founder_ph from '../images/founder_ph.jpg'
import founder from '../images/founder.jpg'

const useStyles = makeStyles((theme) => ({
    profileBorder: {
        borderRight: '1px solid #bfbfbf',
        [theme.breakpoints.down('sm')]: {
            borderRight: 0,
            borderBottom: '1px solid #bfbfbf',
        }
    },
    profileImg: {
        '& div': {
            paddingBottom: '90%',
            [theme.breakpoints.up('md')]: {
                marginRight: theme.spacing(2),
            },
            [theme.breakpoints.only('sm')]: {
                paddingBottom: '32%',
            },
            [theme.breakpoints.only('xs')]: {
                paddingBottom: '48%',
            },
        },
        '& img': {
            objectFit: 'contain',
        },
    },
    profileDetailPadding: {
        [theme.breakpoints.up('md')]: {
            '& p' : {
                paddingLeft: theme.spacing(3),
            },
        },
        [theme.breakpoints.down('sm')]: {
            '& p:first-child': {
                paddingTop: theme.spacing(2),
            }
        }
    }
}))

export default function About() {
    const classes = useStyles();

    return (
        <Grid container spacing={2}>
            <ScrollToTopOnMount/>
            <UpdatePage title='RQuaL Solution -  Consulting Firm Founded by Avtar Singh' />
            <Grid item xs={12}>
                <HeaderImg ph={about_ph} srcMobile={about_mobile} srcDesktop={about_desktop}/>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 2, md: 3 }} mb={{ xs: 1, md: 2 }}>
                    About RQuaL Solutions
                </Box>
                <Typography align='justify' paragraph={true}>
                RQuaL is a Leading Reputed Quality Compliance & Regulatory Consulting Firm founded by Avtar Singh.
                </Typography>
                <Typography align='justify' paragraph={true}>Our firm intends to provide the Pharmaceutical industry with innovative and customized Solutions, so as to ensure safe and reliable access of life-saving Medical products to the People in need of Healthcare products.</Typography>
                <Typography align='justify'>We are a Partner of choice in the Healthcare Industry for providing end to end customized solutions to Complex Matters related to Quality, cGMP Compliance and Regulatory Matters.</Typography>
            </Grid>
            <Grid item xs={12}>
                <Box fontSize="h5.fontSize" mt={{ xs: 2, md: 3 }} mb={{ xs: 1, md: 2 }}>
                    About the Founder
                </Box>
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={classes.profileBorder}>
                <Grid container spacing={1}>
                    <Grid item xs={12} className={classes.profileImg}>
                        <LazyImg placeholder={founder_ph} srcSet={founder} alt="Avtar's Profile" />
                    </Grid>
                    <Grid item xs={12}>
                        <Box textAlign="center" mr={{xs:0, md:2}} mb={{xs: 1, md:0}}>
                            <b>Avtar Singh</b>, RQuaL&nbsp;Founder
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={9} lg={10} className={classes.profileDetailPadding}>
                <Typography align='justify' paragraph={true}><b>Avtar</b> holds a well recognized name in the Quality and Regulatory arena with a proven track record in the pharmaceutical Industry. He has more than 34 Years’ of work ethic and rich practical experience in Quality Control, Quality Assurance, Regulatory Affairs, Research & Development, Production (Sterile and Oral – API / Formulations), Qualification, Validation, Plant Management and Project Management.</Typography>
                <Typography align='justify' paragraph={true}>Majored and specializing in Chemistry, he has worked from the grass root level and understands core issues of the shop floor. Professionally he has risen rapidly from working at the basic bench top to managing his own department. On his way up, in addition to earning repute in Quality & Regulation, he has also looked into various other functions which includes Production, Process development and Core R&D.</Typography>
                <Typography align='justify' paragraph={true}>From turning around facilities with low GMP level understanding to clearing the Green Regulations body, Avtar has been instrumental in building a strong base for the Quality Systems. His belief in building a strong team has proven to lead the facilities to grow in the Regulated Markets.</Typography>
                <Typography align='justify' paragraph={true}>His last role as an industrial professional was heading the Quality, GMP and Regulatory Affairs Business Unit AMEA of Centrient Pharmaceuticals (formerly DSM Sinochem Pharmaceuticals - DSP). He was responsible for all the activities related to Quality, GMP and RA for all the units including the CMO sites. He also played a pivotal role in corporate DSP worldwide. </Typography>
                <Typography align='justify' paragraph={true}>Prior to DSP, Avtar held the position of Vice President Corporate Quality & Regulatory Affairs at Nectar Lifesciences which has production of both Sterile as well as Oral API, Finished Dosage forms, Phyto-chemicals, EHGC, In-vitro Diagnostics and Surgical devices. Apart from his multifaceted corporate role, he was actively involved in the development, manufacturing and compliance of Sterile and Oral Drug substances / products across all the locations. Avtar also headed the Formulation Plant of Nectar Lifesciences, located in Baddi.</Typography>
            </Grid>
        </Grid>
    )
}